
export function isDomElementVisible(element: HTMLElement) {
    if (!element || typeof element.offsetWidth === 'undefined') {
        return false;
    }
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
};
